import React from "react";
import { FormFieldConfig } from "../../../../Components/Common/CommonForm";
import { Column } from "../../../../Components/Common/CommonTableIndexWise";
import { formatDate, parseLocalDate } from "../../../../common/service/CommonService";
import { Link } from "react-router-dom";
import { DROPOUT_VOLUNTEER_PATHS } from "Routes/paths";
import { validations } from "validations/FormValidations";



export const getSubjectFields = (): FormFieldConfig[] => [
  {
    name: "studycode",
    label: "Study Code",
    type: "text",
    required: true,
    disabled: true,
    placeholder: "Select study...",
  },
  {
    name: "subjectno",
    label: "Subject Number",
    type: "text",
    required: true,
    disabled: true,
    placeholder: "Search subject ID...",
  },
  {
    name: "subjectinitial",
    label: "Subject Initial",
    type: "text",
    required: true,
    disabled: true,
    placeholder: "Auto-filled based on Subject ID",
  },

];

export const getDropoutTypeFields = (DROPOUT_TYPE_OPTIONS: any): FormFieldConfig[] => [
  {
    name: "dropouttype",
    label: "Dropout Type",
    type: "select",
    required: true,
    options: DROPOUT_TYPE_OPTIONS,
    placeholder: "Select dropout type...",
  },
];

export const getDropoutDetailsFields = (
  dropoutType: string | null,
  dropoutDate: string | null = null,
  studyStages: any[] = []
): FormFieldConfig[] => {
  const fields: FormFieldConfig[] = [];

  if (dropoutType === "Medical / AE") {
    fields.push({
      name: "aereferenceno",
      label: "AE Reference No.",
      type: "text",
      placeholder: "e.g. AE-2024-017",
      required: true,
      disabled: true
    });
  }

  fields.push(
    {
      name: "dropoutdate",
      label: "Dropout Date",
      type: "date",
      required: true,
    },
    {
      name: "studystage",
      label: "Study Stage",
      type: "select",
      required: true,
      options: studyStages,
      placeholder: "Select Stage...",
    },
    {
      name: "effectivedate",
      label: "Effective Date",
      type: "date",
      required: true,
      disabled: !dropoutDate,
      optionsProps: {
        minDate: dropoutDate ? (parseLocalDate(dropoutDate) || undefined) : undefined,
      },
    }
  );

  return fields;
};

export const getDropoutReasonFields = (DROPOUT_REASONS_OPTIONS: any): FormFieldConfig[] => [
  {
    name: "dropoutreason",
    label: "Dropout Reason",
    type: "select",
    required: true,
    options: DROPOUT_REASONS_OPTIONS,
    placeholder: "Select Reason...",
  },
  {
    name: "detailedremarks",
    label: "Detailed Remarks",
    type: "textarea",
    placeholder: "Enter detailed remarks here...",
    rules: validations.dropoutvolunteer.detailedremarks
  },
];

export const getReplacementFields = (replacementRequired: "Yes" | "No" | null): FormFieldConfig[] => {
  const fields: FormFieldConfig[] = [
    {
      name: "replacementrequired",
      label: "Replacement Required",
      type: "radio",
      required: true,
      options: [
        { label: "Yes - Replacement needed", value: "Yes" },
        { label: "No - Not required", value: "No" },
      ],
    },
  ];

  if (replacementRequired === "Yes") {
    fields.push({
      name: "replacementsubjectid",
      label: "Replacement Subject ID",
      type: "text",
      placeholder: "Search or assign replacement subject",
      description: "Leave blank if replacement not yet assigned.",
    });
  }

  return fields;
};



export const dropoutVolunteerColumns: Column[] = [
  {
    key: "subjectno",
    label: "Study Code / Subject Number",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <Link
            to={
              DROPOUT_VOLUNTEER_PATHS.VIEW.replace(
                ":id",
                String(row?.volunteerdropoutid ?? row?.id ?? "")
              )
            }
            className="mb-0 fw-medium text-primary text-decoration-none d-block"
          >
            {row.studycode || "—"}
          </Link>
          <p className="mb-0 text-muted fs-11">{row.subjectno || "—"}</p>
        </>
      );
    }
  },
  {
    key: "initials",
    label: "Subject Initial"
  },
  {
    key: "dropouttypetext",
    label: "Dropout Type"
  },
  {
    key: "dropoutreasontext",
    label: "Dropout Reason",
  },
  {
    key: "studystage",
    label: "Study Stage",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return row.studystage ? (
        <span className="badge bg-light text-dark border px-2 py-1 fs-11">{row.studystage}</span>
      ) : (
        "—"
      );
    },
  },
  {
    key: "dropoutdate",
    label: "Dropout Date",
    render: (value: any) => (value ? formatDate(value) : "—"),
  },
  {
    key: "verifiedby",
    label: "Verified By",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <p className="mb-0 fw-medium text-dark">{row.verifiedbytext || "—"}</p>
          <p className="mb-0 text-muted fs-12">
            {row.verifieddate ? formatDate(row.verifieddate) : "—"}
          </p>
        </>
      );
    },
  },
];
